export class UnverifiedSession
{
    constructor(readonly sessionToken: string) {     
    }
}